// extracted by mini-css-extract-plugin
export default {"root":"Email_root__-0KJh","header":"Email_header__XXR0F","body":"Email_body__Fgqkd"};